const GlucoseCurve: React.FC = () => {
  return (
    <svg
      className="w-full h-full"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Grid lines */}
      <g className="text-neutral-200" stroke="currentColor" strokeWidth="0.5">
        <line x1="0" y1="20" x2="100" y2="20" />
        <line x1="0" y1="40" x2="100" y2="40" />
        <line x1="0" y1="60" x2="100" y2="60" />
        <line x1="0" y1="80" x2="100" y2="80" />
        <line x1="20" y1="0" x2="20" y2="100" />
        <line x1="40" y1="0" x2="40" y2="100" />
        <line x1="60" y1="0" x2="60" y2="100" />
        <line x1="80" y1="0" x2="80" y2="100" />
      </g>

      {/* Glucose line */}
      <path
        d="M0,70 C10,70 15,40 25,40 C35,40 40,25 50,25 C60,25 65,60 75,60 C85,60 90,50 100,50"
        stroke="#6B46C1"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        className="glucose-line"
      />

      {/* Fill under the curve with gradient */}
      <path
        d="M0,70 C10,70 15,40 25,40 C35,40 40,25 50,25 C60,25 65,60 75,60 C85,60 90,50 100,50 L100,100 L0,100 Z"
        fill="url(#gradient)"
        opacity="0.2"
      />

      {/* Gradient definition */}
      <defs>
        <linearGradient id="gradient" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#6B46C1" />
          <stop offset="100%" stopColor="#6B46C1" stopOpacity="0" />
        </linearGradient>
      </defs>

      {/* Data points */}
      <circle cx="0" cy="70" r="2.5" fill="#6B46C1" />
      <circle cx="25" cy="40" r="2.5" fill="#6B46C1" />
      <circle cx="50" cy="25" r="2.5" fill="#6B46C1" />
      <circle cx="75" cy="60" r="2.5" fill="#6B46C1" />
      <circle cx="100" cy="50" r="2.5" fill="#6B46C1" />

      {/* Animated data point */}
      <circle
        cx="50"
        cy="25"
        r="3.5"
        fill="#6B46C1"
        opacity="0.5"
        className="animate-glucose-animation"
      />
    </svg>
  );
};

export default GlucoseCurve;
